import React, { useContext, useState } from 'react'

const LoadingContext = React.createContext();
const LoadingUpdateContext = React.createContext();

// Custom hook to give easy access 
export function useIsLoading(){
    return useContext(LoadingContext)
}
// Custom hook to give easy access 
export function useIsLoadingUpdate(){
    return useContext(LoadingUpdateContext)
}

export function LoadingProvider({ children }){
    // School Document and Evaluations needs to be implemented from their components to this
    const [isLoading, setIsLoading] = useState(false)

    function toggleIsLoading(){
        setIsLoading(isLoading => !isLoading)
    }

    return(
        <LoadingContext.Provider value={isLoading}>
            <LoadingUpdateContext.Provider value={toggleIsLoading}>
                {children}
            </LoadingUpdateContext.Provider>
        </LoadingContext.Provider>
    )
}

